import { CustomReducer } from 'types/common';
import { TAppVersion } from 'api/types';
import { IVersionStore } from './types';

export const version: CustomReducer<IVersionStore, TAppVersion> = (state, action) => ({
  ...state,
  version: action.payload,
});
